import { object, string, bool } from 'prop-types'
import { css } from '@emotion/react'

import { LocalImage } from '@/components/LocalImage'
import { COL_SIZE } from '@/components/Layout'
import mediaQueries from '@/layout/media-queries'

const campaignImageCss = (sizing) => css`
  width: 100%;
  max-height: 410px;
  margin-bottom: 16px;
  ${sizing === COL_SIZE.large && 'margin-top: 30px;'}

  ${mediaQueries.xsmallScreen(200)} {
    margin-top: 0;
    margin-bottom: 0;
  }

  &,
  img {
    object-fit: contain !important;
  }
`

const mainCampaignCss = (isMobile) => css`
  place-self: center;

  ${mediaQueries.xsmallScreen(200)} {
    ${!isMobile && 'width: 45%;'}
    height: unset;
  }

  ${mediaQueries.smallScreen()} {
    width: 47%;
  }

  ${mediaQueries.mediumScreen()} {
    width: 54%;
  }
`

const AppImage = ({
  campaign,
  sizing,
  isMainCampaign,
  className,
  isMobile,
  alt,
}) => {
  const { properties, image, name } = campaign
  const fallbackUrl =
    properties?.image3x || properties?.image2x || properties?.image1x

  return (
    <LocalImage
      image={image}
      alt={name || alt}
      fallbackUrl={fallbackUrl}
      className={className || ''}
      css={[
        campaignImageCss(sizing),
        isMainCampaign && mainCampaignCss(isMobile),
      ]}
      dataTest={`image-${campaign.id}`}
    />
  )
}

AppImage.propTypes = {
  campaign: object,
  sizing: string,
  isMainCampaign: bool,
  className: string,
  isMobile: bool,
  alt: string,
  dataTest: string,
}

export default AppImage
